module.exports = __webpack_public_path__ + "media/target_missed.0b37238b.mp3";